"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var Confirmation_1 = require("../../Confirmation");
var moment = require("moment");
var Tree_1 = require("../../../components/Tree");
var UnlockVRNChange = /** @class */ (function (_super) {
    __extends(UnlockVRNChange, _super);
    function UnlockVRNChange(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showUnlockVRNChangeAction: false,
            showUnlockVRNChangeConfirmation: false
        };
        return _this;
    }
    UnlockVRNChange.prototype.componentDidMount = function () {
        var _this = this;
        this.supportPortalService.getLastVRNChangeDate(this.props.personId, this.props.policyVersion.policyNumber)
            .subscribe(function (date) {
            if (date != null) {
                var lastVRNChangeDate = moment(date, "YYYY-MM-DD");
                var now = moment();
                _this.setState({ showUnlockVRNChangeAction: lastVRNChangeDate.isValid() && !lastVRNChangeDate.add(1, "year").isBefore(now) });
            }
        });
    };
    UnlockVRNChange.prototype.render = function () {
        var _this = this;
        if (!this.props.isMTC && this.props.interaction) {
            if (this.state.showUnlockVRNChangeAction) {
                return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("a", { className: "d-block text-primary on-hover-underline", onClick: function () { return _this.setState({ showUnlockVRNChangeConfirmation: true }); }, children: " Unlock VRN change" }), (0, jsx_runtime_1.jsx)(Confirmation_1.default, { show: this.state.showUnlockVRNChangeConfirmation, hide: function () { return _this.setState({ showUnlockVRNChangeConfirmation: false }); }, confirm: function () { return _this.startAction(); }, title: "", message: "Are you sure you want to unlock VRN change?" })] }) }));
            }
        }
        return null;
    };
    UnlockVRNChange.prototype.startAction = function () {
        this.supportPortalService.unlockVRNChange(this.props.personId, this.props.policyVersion.policyNumber, this.props.vehicleRegistrationNumber).subscribe();
        this.setState({ showUnlockVRNChangeAction: false });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], UnlockVRNChange.prototype, "supportPortalService", void 0);
    UnlockVRNChange = __decorate([
        components_1.authorize,
        (0, components_1.role)("Administrator", "CSR_Lead", "CSR", "Fraud"),
        __metadata("design:paramtypes", [Object])
    ], UnlockVRNChange);
    return UnlockVRNChange;
}(React.Component));
exports.default = UnlockVRNChange;
//# sourceMappingURL=UnlockVRNChange.js.map